import React, { memo, useCallback, useMemo } from 'react'

import {
  Icon,
  Button,
  License as LicenseIcon,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

import LicenseContent from 'Pods/SearchPage/Shared/LicenseContent/LicenseContent'
import { clearLicenses } from 'Pods/SearchPage/Store/actions/licenses'
import { LICENSE_TYPE } from 'Pods/SearchPage/Store/constants'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'
import FiltersWrapper from 'Pods/Shared/FiltersWrapper/FiltersWrapper'

const prefixIcon = <Icon notSpaced svgComponent={LicenseIcon} color="dark" size="small" />

function License() {
  const licenses = useSearchPageStore(state => state.licenses)
  const aiUsageAllowed = useSearchPageStore(state => state.aiUsageAllowed)

  const hasSelectedAnyFilter = useMemo(() => {
    return licenses[0] !== LICENSE_TYPE.ALL || aiUsageAllowed
  }, [licenses, aiUsageAllowed])

  const handleReset = useCallback(() => {
    clearLicenses()
  }, [])

  const content = useMemo(() => (
    <>
      <LicenseContent />
      <Button
        type="ghost"
        size="tiny"
        customClass="filter-wrapper__reset-button"
        onClick={handleReset}
        disabled={!hasSelectedAnyFilter}
      >
        Reset
      </Button>
    </>
  ), [handleReset, hasSelectedAnyFilter])

  return (
    <FiltersWrapper
      placeholder="License"
      prefixIcon={prefixIcon}
      content={content}
      hasSelectedAnyFilters={hasSelectedAnyFilter}
      closingDropdownClassName="filter-wrapper"
    />
  )
}

export default memo(License)
